import React from 'react'
import { useStoreView } from 'hooks/useStoreView'
import { MenuDropdown } from './components/MenuDropdown'
import { Wrapper, Item } from './components/Styled'

interface Props {
  label: string
  block?: string
}

export const MenuItem = ({ label, block }: Props) => {
  const { isLivBrite } = useStoreView()
  return (
    <Wrapper>
      <Item
        isLivBrite={isLivBrite}
      >
        <p><span>{label}</span></p>
        {block && (
          <MenuDropdown
            blockId={block}
          />
        )}
      </Item>
    </Wrapper>
  )
}
